module.exports = __webpack_public_path__ + "img/integration5.b3ed3c6e.png";